import script from "./HandlebarSelectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandlebarSelectionView.vue?vue&type=script&setup=true&lang=ts"

import "./HandlebarSelectionView.vue?vue&type=style&index=0&id=7be2b686&lang=scss"

const __exports__ = script;

export default __exports__